import { IProjectCategory } from 'Content/Projects/types';

const data: IProjectCategory = {
    id: 'commercial',
    title: {
        en: 'commercial',
        he: 'מסחר',
    },
    text: {
        en: 'buildings of collaborative use. Forming architectural solutions to balance mix-use functions in complex spatial contexts.',
        he: 'מבני שימוש משותף. עיצוב פתרונות אדריכליים המאזנים בין שימושים מעורבים בתוך הקשרים מרחביים מורכבים.',
    },
    stripIndex: 8,
    projects: []
};

export default data;